// 스타일
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import styles from "./RpMainGrid.module.css";

const AiRecommendationCard = ({ 
  /**
   * @param {string} id - id of the recommendation card.
   * @param {string} title - The title of the recommendation card.
   * @param {string} summary - A brief summary displayed under the title.
   * @param {string} details - Detailed description text displayed in the details section.
   * @param {string} buttonText - The text to display on the action button.
   * @param {string} imageUrl - URL of the main image displayed in the card header.
   * @param {string} detailImageUrl - URL of the image displayed on the left side of the details section.
   * @param {string} detailRightImageUrl - URL of the image displayed on the right side of the details section.
   */
  id,
  title, 
  subtitle, 
  summary, 
  details, 
  buttonText, 
  imageUrl, 
  detailImageUrl, 
  detailRightImageUrl,
  is_main_page_use,  
  is_detail_page_use,
  is_cart_page_use,
  is_order_complete_page_use,
  onClickButton
}) => {
    window.addEventListener('resize', () => {
      const container = document.querySelector('#' + id + ' .card-detail-right-image-container');
      if (window.innerWidth <= 1024) {
        if (!detailRightImageUrl) {
            container.style.height = '0';
        } else {
          container.style.height = 'none';
        }
      } else {
        container.style.height = 'none';
      }
    });
    return (
      <div className="ai-recommendation-card" id={id}>
        <div className="card-header">
          <div className="card-title-subtitle">
            <h2 className="card-title">{title}</h2>
            <span className="card-subtitle">{subtitle && " | "}</span>
            <h3 className="card-subtitle">{subtitle}</h3>
          </div>
          <p className="card-summary">{summary}</p>
        </div>
        <div className="card-details">
          <div className="card-detail-left-image-container-container">
            <div className="card-detail-left-image-container"
              style={{
                backgroundImage: `url(${detailImageUrl})`
              }}
            ></div>
          </div>
          <div
            className="card-description"
            dangerouslySetInnerHTML={{ __html: details }}
          ></div>
          <div className="card-detail-right-image-container" 
          style={{
            backgroundImage: `url(${detailRightImageUrl})`,
            height: window.innerWidth <= 1024 ? !detailRightImageUrl ? '0' : 'none' : 'none'
          }}
          ></div>
        </div>
        <div className="card-button-container">
          <div className="card_tags">
            { is_main_page_use == "Y" && <span>#메인페이지</span> }
            { is_detail_page_use == "Y" && <span>#상품상세페이지</span> }
            { is_cart_page_use == "Y" && <span>#장바구니페이지</span> }
            { is_order_complete_page_use == "Y" && <span>#구매완료페이지</span> }
          </div>
          <button className="card-button hover_mint" onClick={() => onClickButton()}>{buttonText}</button>
        </div>
      </div>
    );
  };

export default AiRecommendationCard;